var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dropdown-menu",
      attrs: { id: "dropdown-menu", role: "menu" },
    },
    [
      _c(
        "div",
        {
          ref: "dropdownContent",
          staticClass: "dropdown-content",
          staticStyle: {
            "white-space": "nowrap",
            "overflow-x": "auto",
            "min-width": "250px",
            "max-width": "100vw",
            "max-height": "300px",
            "overflow-y": "auto",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "pl-4 pr-4 is-flex is-justify-content-space-between",
            },
            [
              _c("span", [_vm._v("Please Select")]),
              _vm.selectedTags.length > 0
                ? _c("button", { on: { click: _vm.resetSelectedTags } }, [
                    _vm._m(0),
                    _c("span", [_vm._v("Clear All")]),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._l(_vm.tags, function (tag) {
            return _c(
              "div",
              {
                key: tag.tagID,
                staticClass: "dropdown-item is-flex is-align-items-center",
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    return _vm.toggleTag(tag)
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tag-short mr-2",
                    style: {
                      backgroundColor: tag.colorHex,
                      color: _vm.getTextColor(tag.colorHex),
                    },
                  },
                  [_vm._v(_vm._s(tag.shortTag))]
                ),
                _c("span", { staticClass: "mr-auto" }, [
                  _vm._v(_vm._s(tag.tagName)),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "pretty p-icon p-curve p-smooth p-bigger ml-2",
                  },
                  [
                    _c("input", {
                      staticStyle: { cursor: "pointer" },
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: _vm.selectedTags.includes(tag.tagID),
                      },
                      on: {
                        change: function ($event) {
                          $event.stopPropagation()
                          return _vm.toggleTag(tag)
                        },
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "state p-primary",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleTag(tag)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "icon mdi mdi-check" }),
                        _c("label"),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }